import React from "react";
import styles from "./StatsCard.module.css";
import type { iconProps, statsCardProps, statsGridProps } from "./types.props";

const StatsCard: React.FC<statsCardProps> = ({
    icon,
    label,
    value,
    className = "",
    iconColor = "#6b7280",
}) => {
    const renderIcon = () => {
        if (React.isValidElement(icon)) {
            return React.cloneElement(icon as React.ReactElement<iconProps>, {
                size: 24,
                color: iconColor,
            });
        }
        return icon;
    };

    return (
        <div className={`${styles["stats-card"]} ${className}`}>
            <div className={styles["card-content"]}>
                <div className={styles["text-container"]}>
                    <p className={styles["stats-label"]}>{label}</p>
                    <p className={styles["stats-value"]}>{value}</p>
                </div>
                <div
                    className={styles["icon-wrapper"]}
                    style={{ backgroundColor: `${iconColor}20` }}
                >
                    {renderIcon()}
                </div>
            </div>
        </div>
    );
};

const StatsGrid: React.FC<statsGridProps> = ({ items }) => {
    return (
        <div className={styles["stats-grid"]}>
            {items.map((item, index) => (
                <StatsCard
                    key={index}
                    icon={item.icon}
                    label={item.label}
                    value={item.value}
                    iconColor={item.iconColor}
                />
            ))}
        </div>
    );
};

export default StatsGrid;
